import { Pipe, PipeTransform } from '@angular/core';
import { userNameUtils } from '@shared/utils/user-name.utils';

@Pipe({
  name: 'translateUsers'
})
export class TranslateUsersPipe implements PipeTransform {

  transform(userName: string | number): string {
    const name = userNameUtils(userName)
    return typeof name === 'number'
      ? name.toString()
      : name;
  }

}
